export default "__VITE_ASSET__CN9sAu6t__"